import BossModel from "@/models/BossModel";
import WebsiteRoute from "@/models/WebsiteRoute/WebsiteRoute";

export default class WebsiteFooterLink extends BossModel {

    /**
     *
     * @type {string}
     */
    static apiUrl = 'website-footer-link';

    /**
     *
     * @type {string}
     */
    static entity = 'websiteFooterLinks';

    static fields() {
		return {
			id: this.number(null).nullable(),
			rank: this.number(null).nullable(),
			name: this.attr(null),
			link_url: this.attr(null),
			website_route_id: this.number(null).nullable(),
			website_footer_link_category_id: this.attr(null),
			created_at: this.attr(null),
			updated_at: this.attr(null),
            route: this.belongsTo(WebsiteRoute, 'website_route_id'),
		}
	}

    /**
     *
     * @returns {boolean|*}
     * @constructor
     */
    Route() {
        return this.getRelated('route');
    }
}
